import * as React from 'react';
import defaultBackground from './assets/background.png';
import suburbanRKBackground from './assets/suburbanRK.jpg';
import { BackgroundContext } from './context';
import { useApplicationContext } from '../../utils/applicationContext';

export const BackgroundProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const { config } = useApplicationContext();

  const state = React.useState<string>(() => {
    return config.get<string>('suburbanRK.title') ? suburbanRKBackground : defaultBackground;
  });

  return <BackgroundContext.Provider value={state}>{children}</BackgroundContext.Provider>;
};
